<template>
  <div class="adherent-params">
    <h2>Paramétrage des adhérents</h2> <br />
    <div class="card shadow mb-4">
      <!-- Card Header - Dropdown -->
      <div class="card-header py-3 d-flex flex-row align-items-center">
        <h6 :class="!displayExcluded ? 'text-primary' : 'text-secondary'" @click="displayExcluded = false"><i class="fas fa-map-marked-alt me-2" />Paramètres de carte</h6>
        <h6 :class="displayExcluded ? 'text-primary' : 'text-secondary'" @click="displayExcluded = true"><i class="fas fa-users-slash me-2" />Exclusions</h6>
      </div>
      <!-- Card Body -->
      <div class="mapParams p-3" v-if="!displayExcluded">
        <div>
          <table class="table table-responsive">
            <tr>
              <th>Groupement</th>
              <th>Logo</th>
              <th></th>
              <th>Marqueur</th>
              <th></th>
              <th>Couleur</th>
              <th></th>
            </tr>
            <tr v-for="(adherentParam, index) in adherentParams" :key="adherentParam.GroupementGuid">
              <td>{{ adherentParam.GroupementName }}</td>
              <td><img class="images" :src="printImageLogo(adherentParam.Logo)" /></td>
              <td><input type="file" id="logo" ref="imageLogo" name="logo" v-on:change="uploadImageLogo(index, adherentParam.GroupementGuid)" accept="image/png, image/jpg"></td>
              <td><img class="images" :src="printImageMarker(adherentParam.Marker)" /></td>
              <td><input type="file" id="marker" ref="imageMarker" attr="index" name="marker" v-on:change="uploadImageMarker(index, adherentParam.GroupementGuid)" accept="image/png, image/jpg"></td>
              <td><input class="form-control" id="colorAdherent" type="color" v-model="adherentParam.PopupWrapperColor" /></td>
              <td><button type="button" class="btn-save" v-on:click="updateParamAdherent(adherentParam)">Enregistrer</button></td>
            </tr>
          </table>
        </div>
      </div>
      <div class="exclusionParams p-3" v-else>
        <div>
          <table class="table table-responsive">
            <tr>
              <th>Groupement</th>
              <th></th>
            </tr>
            <tr v-for="adh of adhExclusionsSorted" :key="adh.Guid">
              <td>{{ adh.Name }}</td>
              <td><button type="button" id="btn-suppr" class="btn-suppr" @click="deleteExclusion(adh.Guid)">Supprimer</button></td>
            </tr>
            <tr>
              <td>
                <select class="form-control" v-model="exclusionModel">
                  <option v-for="adh of allAdhSorted" :key="adh.Guid" :value="adh.Guid">{{ adh.Name }}</option>
                </select>
              </td>
              <td><button class="btn btn-add" @click="addExclusion(exclusionModel)">Ajouter</button></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import { initAdherentParams } from "@/utils/adminMapsMixin";
  import { apiFetch, apiPost, apiPostMaps } from "@/utils";

  export default {
    name: "Adherents",
    data() {
      return {
        fileLogo: '',
        fileMarker: '',
        exclusionModel: '',
        adherentParams: [],
        adhExclusions: [],
        allAdh: [],
        displayExcluded: false
      }
    },
    mounted() {
      this.initData();
    },
    methods: {
      initData() {
        initAdherentParams().then(res => {
          this.adherentParams = res.adherentParams;
          this.adhExclusions = res.adhExclusions;
          this.allAdh = res.allAdh;
        })
      },

      uploadImageLogo(index, guid) {
        this.fileLogo = this.$refs.imageLogo[index].files[0];
        var ap = this.adherentParams.find(e => e.GroupementGuid == guid);
        if (ap != undefined) {
          ap.fileLogo = this.$refs.imageLogo[index].files[0];
        }
      },

      uploadImageMarker(index, guid) {
        this.fileMarker = this.$refs.imageMarker[index].files[0];
        var ap = this.adherentParams.find(e => e.GroupementGuid == guid);
        if (ap != undefined) {
          ap.fileMarker = this.$refs.imageMarker[index].files[0];
        }
      },

      printImageLogo(nameImage) {
        var images = 'https://maps.cmem-mat.info/api/logo/' + nameImage
        return images;
      },

      printImageMarker(nameImage) {
        var images = 'https://maps.cmem-mat.info/api/markers/' + nameImage
        return images;
      },
      addExclusion(guid) {
        apiPost("maps/adherents/parameters/exclusion/add", { guid }).then(() => {
          this.initData();
        })
      },
      deleteExclusion(guid) {
        apiPost("maps/adherents/parameters/exclusion/delete", { guid }).then(() => {
          this.initData();
        })
      },
      updateParamAdherent(adherent) {

        if (adherent.fileLogo != undefined) {
          this.fileLogo = adherent.fileLogo;
        }
        if (adherent.fileMarker != undefined) {
          this.fileMarker = adherent.fileMarker;
        }

        apiPostMaps("adherents/parameters/id/update?guid=" + adherent.GroupementGuid + "&logo=" + this.fileLogo.name + "&marker=" + this.fileMarker.name + "&popupColor=" + adherent.PopupWrapperColor.replace("#", "%23"),
          {
            logo: this.fileLogo,
            marker: this.fileMarker
          }).then(() => {
          this.initData();
          alert("Sauvegarde effectuée avec succés");
        })
      },
    },
    computed: {
      allAdhSorted() {
        return this.allAdh.slice().sort((a, b) => a.Name < b.Name ? -1 : 1)
      },
      adhExclusionsSorted() {
        return this.adhExclusions.slice().sort((a, b) => a.Name < b.Name ? -1 : 1)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .images {
    max-width: 50px;
    max-height: 50px;
  }

  h6 {
    transition: all ease 0.3s;
  }

    h6 i {
      margin-right: 6px;
    }

    h6:not(:last-child) {
      margin-right: 1rem;
    }

    h6:hover {
      filter: brightness(85%);
      cursor: pointer;
    }

  .btn-add {
    background: #7ED321;
  }
</style>




// WEBPACK FOOTER //
// src/pages/Admin/AdminMaps/Adherents.vue